export const STATUS = { 
    NEW: "NEW",
    DRAFT: "DRAFT",
    INCOMPLETE: "INCOMPLETE",
    SUBMITTED: "SUBMITTED"
}